import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import FeeSystemMenu from "./FeeSystemMenu";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import Dropdown from "react-bootstrap/Dropdown";
import { Form, Modal, Button } from "react-bootstrap";
import { scrollToTop } from "../Shared/ScrollOnTop";

function PrintVouchers(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  //const [DefaultSession, setDefaultSession] = useState(localStorage.getItem("DefaultSession"));

  const [showFilters, setShowFilters] = useState(true);

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [validated, setValidated] = useState(false);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [NewWingId, setNewWingId] = useState(0);
  const [NewClassId, setNewClassId] = useState(0);
  const [WingId, setWingId] = useState(0);
  const [SessionId, setSessioinId] = useState(
    localStorage.getItem("DefaultSession")
  );
  const [ClassId, setClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [SelectedMonth, setSelectedMonth] = useState(moment().format("M"));
  const [SelectedYear, setSelectedYear] = useState(moment().format("YYYY"));
  const [PaidStatusFilter, setPaidStatusFilter] = useState(0);

  const [isUpdated, setIsUpdated] = useState(false);

  const [Registration_No, SetRegistrationNo] = useState("");
  const [Keywords, setKeywords] = useState("");
  const [ChallanNoFilter, setChallanNoFilter] = useState("");
  const [referenceTypeFilter, setReferenceTypeFilter] = useState("");
  /** Numeric filter: challans for this tblChalanHead.Student_ID (0 = all). */
  const [studentIdFilter, setStudentIdFilter] = useState("");

  const [selectedStudents, setselectedStudents] = useState([]);

  const [validatedPrint, setvalidatedPrint] = useState(false);

  const [bulkRemarksText, setBulkRemarksText] = useState("");
  const [bulkRemarksScope, setBulkRemarksScope] = useState("selected"); // "selected" | "filtered"
  const [bulkRemarksLoading, setBulkRemarksLoading] = useState(false);

  // Installment modal: convert single challan to multiple sub-challans (max 4)
  const [showInstallmentModal, setShowInstallmentModal] = useState(false);
  const [installmentChallanNo, setInstallmentChallanNo] = useState("");
  const [installmentCount, setInstallmentCount] = useState(2);
  const [installmentDueDates, setInstallmentDueDates] = useState([]);
  const [installmentSubmitting, setInstallmentSubmitting] = useState(false);

  // Fee heads selection removed (always print all heads)

  useEffect(() => {
    document.title = "Print Vouchers";

    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      SessionID: SessionId,
      Wing_Id: NewWingId,
      Class_Id: NewClassId,
      Section_Id: SectionID,
      SelectedMonth: SelectedMonth,
      FYear: SelectedYear,
      Keywords: Keywords,
      Registration_No: Registration_No,
      ChallanNo: ChallanNoFilter || undefined,
      Reference_ID_Type: referenceTypeFilter || undefined,
      PaidStatusFilter: PaidStatusFilter,
      Student_ID: (() => {
        const n = parseInt(String(studentIdFilter).trim(), 10);
        return !Number.isNaN(n) && n > 0 ? n : 0;
      })(),
    };

    ////console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/GetChalanHeads",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////console.log(response.data);
        setLedger(response.data.ListofRecords || []);
        setLoading(false);
        setTotalRecords(response.data.totalRecords);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [
    pageNo,
    pageSize,
    SessionId,
    NewWingId,
    NewClassId,
    SectionID,
    SelectedMonth,
    SelectedYear,
    Registration_No,
    ChallanNoFilter,
    referenceTypeFilter,
    PaidStatusFilter,
    studentIdFilter,
    isUpdated,
  ]);

  const handleBulkRemarksUpdate = () => {
    const remarks = bulkRemarksText;
    if (bulkRemarksScope === "selected" && selectedStudents.length === 0) {
      toast.error("Select at least one challan, or switch to “all matching filters”.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (bulkRemarksScope === "filtered" && totalRecords === 0) {
      toast.error("No challans match the current filters.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (
      bulkRemarksScope === "filtered" &&
      totalRecords > 0 &&
      !window.confirm(
        `Update remarks on all ${totalRecords} challan(s) matching the current filters (all pages)?`
      )
    ) {
      return;
    }

    setBulkRemarksLoading(true);
    const userName = localStorage.getItem("UserName") || "";
    const filterStudentId = (() => {
      const n = parseInt(String(studentIdFilter).trim(), 10);
      return !Number.isNaN(n) && n > 0 ? n : 0;
    })();

    const payload = {
      AccessKey,
      UserID,
      MemberType,
      UserName: userName,
      Remarks: remarks,
      BulkRemarksApplyToCurrentFilter: bulkRemarksScope === "filtered",
      Challan_Nos: bulkRemarksScope === "selected" ? [...selectedStudents] : null,
      SessionID: SessionId,
      Wing_Id: NewWingId,
      Class_Id: NewClassId,
      Section_Id: SectionID,
      SelectedMonth,
      FYear: SelectedYear,
      Keywords,
      Registration_No,
      ChallanNo: ChallanNoFilter || undefined,
      Reference_ID_Type: referenceTypeFilter || undefined,
      PaidStatusFilter,
      Student_ID: filterStudentId,
    };

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/BulkUpdateChallanHeadRemarks",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          const n = response.data.rowsAffected;
          toast.success(
            typeof n === "number"
              ? `${response.data.status_message} (${n} row(s)).`
              : response.data.status_message,
            { position: toast.POSITION.TOP_RIGHT }
          );
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message || "Update failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error while updating remarks.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setBulkRemarksLoading(false));
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>
              <div className="form-check">
                <input
                  key={item.ID}
                  data-type-id={item.ID}
                  className="form-check-input checkStudent"
                  type="checkbox"
                  value={String(item.Challan_No || "").trim()}
                  checked={selectedStudents.includes(String(item.Challan_No || "").trim())}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    const challanNo = String(e.target.value || "").trim();
                    if (isChecked) {
                      setselectedStudents((prev) => [...prev, challanNo]);
                    } else {
                      setselectedStudents((prev) =>
                        prev.filter((id) => id !== challanNo)
                      );
                    }
                  }}
                />
              </div>
            </td>
            <td>{item.Challan_No}</td>
            <td>{item.Student_ID != null ? item.Student_ID : ""}</td>
            <td>{item.Registration_No}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>{item.Class_Name}</td>
            <td>{item.Section_Name}</td>
            <td>{item.Month}-{item.Year}</td>
            <td>{moment(item.Due_Date).format("DD/MM/YYYY")}</td>
            <td>{item.Due_Date_Amount}</td>
            <td>{item.Is_Paid ? "Paid" : "Unpaid"}</td>
            <td>
              <ul className="inline-action">
                <li>
                  <NavLink
                    to={`/students/PrintVoucher?ChallanNos=${String(
                      item.Challan_No || ""
                    ).trim()}`}
                    target="_blank"
                    className="blue"
                    title="Print Voucher"
                  >
                    <i className="ri-printer-line"></i>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={`/FeeSystem/EditChallan?ChallanNo=${encodeURIComponent(
                      String(item.Challan_No || "").trim()
                    )}`}
                    className="green"
                    title="Edit Challan"
                  >
                    <i className="ri-edit-line"></i>
                  </NavLink>
                </li>
                <li>
                  <button
                    type="button"
                    onClick={() => {
                      const cn = String(item.Challan_No || "").trim();
                      setInstallmentChallanNo(cn);
                      setInstallmentCount(2);
                      const base = moment();
                      setInstallmentDueDates([base.format("YYYY-MM-DD"), base.add(1, "month").format("YYYY-MM-DD")]);
                      setShowInstallmentModal(true);
                    }}
                    className="btn btn-warning btn-sm border-0"
                    title="Convert to Installments"
                    disabled={item.Is_Paid}
                    style={{ opacity: item.Is_Paid ? 0.5 : 1, cursor: item.Is_Paid ? "not-allowed" : "pointer" }}
                  >
                    <i className="ri-calendar-check-line"></i>
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => handleDeleteChallan(String(item.Challan_No || "").trim())}
                    className="red"
                    title="Delete Challan"
                    disabled={item.Is_Paid}
                    style={{ opacity: item.Is_Paid ? 0.5 : 1, cursor: item.Is_Paid ? 'not-allowed' : 'pointer' }}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="13">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const handleDeleteChallan = (challanNo) => {
    if (!window.confirm(`Are you sure you want to delete challan ${challanNo}? This action cannot be undone.`)) {
      return;
    }

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ChallanNo: challanNo,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "MonthlyTask/DeleteChallan",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsUpdated(true); // Refresh the list
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        toast.error("Error deleting challan", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleInstallmentCountChange = (e) => {
    const n = parseInt(e.target.value, 10) || 2;
    setInstallmentCount(n);
    setInstallmentDueDates((prev) => {
      const next = [];
      const base = moment();
      for (let i = 0; i < n; i++) next.push(prev[i] || base.clone().add(i, "month").format("YYYY-MM-DD"));
      return next;
    });
  };

  const handleInstallmentDueDateChange = (index, value) => {
    setInstallmentDueDates((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const handleConvertToInstallments = () => {
    if (!installmentChallanNo || installmentDueDates.length !== installmentCount) {
      toast.error("Please select due dates for all installments.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    const invalid = installmentDueDates.some((d) => !d || !d.trim());
    if (invalid) {
      toast.error("Please select a valid date for each installment.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    setInstallmentSubmitting(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ChallanNo: installmentChallanNo,
      NumberOfInstallments: installmentCount,
      InstallmentDueDates: installmentDueDates.map((d) => d.trim()),
    };
    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/ConvertChallanToInstallments",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, { position: toast.POSITION.TOP_RIGHT });
          setShowInstallmentModal(false);
          setIsUpdated(true);
        } else {
          toast.error(response.data.status_message || "Failed to convert challan", { position: toast.POSITION.TOP_RIGHT });
        }
      })
      .catch(() => {
        toast.error("Error converting challan to installments", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => setInstallmentSubmitting(false));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        pageNo: pageNo,
        pageSize: pageSize,
        SessionID: SessionId,
        Wing_Id: NewWingId,
        Class_Id: NewClassId,
        Section_Id: SectionID,
        SelectedMonth: SelectedMonth,
        FYear: SelectedYear,
        Keywords: Keywords,
        Registration_No: Registration_No,
        ChallanNo: ChallanNoFilter || undefined,
        Reference_ID_Type: referenceTypeFilter || undefined,
        PaidStatusFilter: PaidStatusFilter,
        Student_ID: (() => {
          const n = parseInt(String(studentIdFilter).trim(), 10);
          return !Number.isNaN(n) && n > 0 ? n : 0;
        })(),
      };

      ////console.log(data);

      var api_config = {
        method: "post",
        url: config.base_url + "MonthlyTask/GetChalanHeads",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          ////console.log(response.data);
          setLedger(response.data.ListofRecords || []);
          setLoading(false);
          setTotalRecords(response.data.totalRecords);
        })
        .catch(function (error) {
          //console.log(error);
        });
    }

    setValidated(true);
  };

  //handlePromote
  const handlePrintVoucher = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setLoading(true);

      const inputsStudents = document.querySelectorAll("input.checkStudent");
      const valuesSelected = [];
      inputsStudents.forEach((input) => {
        if (input.checked == true) {
          const value = input.value;
          if (value) {
            valuesSelected.push(value);
          }
        }
      });
      setselectedStudents(valuesSelected);

      // Example API call structure (if needed):
      // const apiData = {
      //   AccessKey: AccessKey,
      //   UserID: UserID,
      //   MemberType: MemberType,
      //   SeletedClassNames: feeCodesArray, // Array of strings
      //   // ... other parameters
      // };

      // window.open('/Students/PrintVoucher/?Class_Id=' + NewClassId + '&ConcessionRuleID=' + ConcessionRuleID , '_blank');

      setLoading(false);
      //console.log(valuesSelected);
    }

    setvalidatedPrint(true);
  };

  const buildPrintVoucherUrl = () => {
    if (selectedStudents.length > 0) {
      const storageKey = `pv_sel_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2, 8)}`;
      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            challanNos: selectedStudents,
            createdAt: Date.now(),
          })
        );
      } catch (e) {
        // Fallback to URL mode if browser storage is unavailable.
        return `/students/PrintVoucher?ChallanNos=${selectedStudents.join("~")}`;
      }
      return `/students/PrintVoucher?SelectionKey=${encodeURIComponent(storageKey)}`;
    }

    return `/students/PrintVoucher?Wing_Id=${encodeURIComponent(
      String(NewWingId || 0)
    )}&Class_Id=${encodeURIComponent(
      String(NewClassId || 0)
    )}&Section_Id=${encodeURIComponent(
      String(SectionID || 0)
    )}&SessionID=${encodeURIComponent(
      String(SessionId || 0)
    )}&SelectedMonth=${encodeURIComponent(
      String(SelectedMonth || "")
    )}&FYear=${encodeURIComponent(
      String(SelectedYear || "")
    )}&PaidStatusFilter=${encodeURIComponent(
      String(PaidStatusFilter || 0)
    )}&Reference_ID_Type=${encodeURIComponent(
      String(referenceTypeFilter || "")
    )}`;
  };

  const handleOpenPrintVouchers = () => {
    const printUrl = buildPrintVoucherUrl();
    window.open(printUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Students
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Print Vouchers
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Print Vouchers</div>
              </div>

              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/students/AddStudent"
                    className="button button-white button-icon"
                  >
                    Add Students
                    <i className="ri-add-fill"></i>
                  </NavLink>
                  <button
                    onClick={() => {
                      setShowFilters((prevIsActive) => !prevIsActive);
                    }}
                    className="button button-white button-icon"
                  >
                    {showFilters ? "Hide Filters" : "Show Filters"}
                    <i className="ri-filter-3-line"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`collapse ${showFilters ? "show" : ""} `}
          id="collapseFilteres"
        >
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="page-content">
              <div className="container">
                <div className="card mb-2">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Session:</label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setSessioinId(e.target.value);
                              setWingId(0);
                              setClassId(0);
                              setSectionID(0);
                            }}
                            name="SessionID"
                          >
                            <option value="">---All---</option>
                            <SessionsDropDown selectedSession={SessionId} />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label>Select Wing:</label>
                          <select
                            name="Wing_Id"
                            onChange={(e) => {
                              setNewWingId(e.target.value);
                              setClassId(0);
                              setSectionID(0);
                            }}
                            className="form-select"
                          >
                            <option value="0">---All---</option>
                            <WingsDropDown />
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Select Class:</label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setNewClassId(e.target.value);
                              setSectionID(0);
                            }}
                            name="Class_ID"
                          >
                            <option value="">Please Select</option>
                            {SessionId != 0 && NewWingId != 0 && (
                              <ClassesDropDown
                                SessionID={SessionId}
                                WingID={NewWingId}
                              />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Select Section:</label>
                          <select
                            className="form-select"
                            onChange={(e) => setSectionID(e.target.value)}
                            name="Section_Id"
                          >
                            <option value="0">Please Select</option>
                            {NewClassId !== 0 && (
                              <SectionDropDown ClassID={NewClassId} />
                            )}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Month:</label>
                          <select
                            className="form-select"
                            onChange={(e) => setSelectedMonth(e.target.value)}
                            value={SelectedMonth}
                          >
                            <option value="">Please Select</option>
                            <MonthsDropDown />
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Year:</label>
                          <select
                            className="form-select"
                            onChange={(e) => setSelectedYear(e.target.value)}
                            value={SelectedYear}
                          >
                            <option value="">Please Select</option>
                            <YearsDropDown />
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Registration No:</label>
                          <input
                            type="text"
                            name="Registration_No"
                            value={Registration_No}
                            onChange={(e) => {
                              setPageNo(1);
                              SetRegistrationNo(e.target.value);
                            }}
                            className="form-control"
                            placeholder="Registration No"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Student ID:</label>
                          <input
                            type="number"
                            min="1"
                            name="Student_ID"
                            value={studentIdFilter}
                            onChange={(e) => {
                              setPageNo(1);
                              setStudentIdFilter(e.target.value);
                            }}
                            className="form-control"
                            placeholder="Filter by student ID"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Challan / Voucher No:</label>
                          <input
                            type="text"
                            name="ChallanNo"
                            value={ChallanNoFilter}
                            onChange={(e) => {
                              setPageNo(1);
                              setChallanNoFilter(e.target.value);
                            }}
                            className="form-control"
                            placeholder="Challan or voucher number"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Keywords:</label>
                          <input
                            type="text"
                            name="Keywords"
                            value={Keywords}
                            onChange={(e) => setKeywords(e.target.value)}
                            className="form-control"
                            placeholder="Reg No, Challan No, Student Name"
                          />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Status:</label>
                          <select
                            className="form-select"
                            value={PaidStatusFilter}
                            onChange={(e) => {
                              setPageNo(1);
                              setPaidStatusFilter(parseInt(e.target.value));
                            }}
                          >
                            <option value={0}>All</option>
                            <option value={1}>Paid</option>
                            <option value={2}>Unpaid</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group mb-3">
                          <label className="">Challan Type:</label>
                          <select
                            className="form-select"
                            value={referenceTypeFilter}
                            onChange={(e) => {
                              setPageNo(1);
                              setReferenceTypeFilter(e.target.value);
                            }}
                          >
                            <option value="">All</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Installment">Installment</option>
                            <option value="Admission">Admission</option>
                            <option value="Advance">Advance</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-2 offset-md-1">
                        <div className="form-group">
                          <button
                            type="submit"
                            value="Search"
                            onClick={handleSubmit}
                            className="button button-primary mt-4 w-100"
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body">
                {/* <div className="text-end mb-2 me-3">
                                    <b>{{totalRecords}} &nbsp; Records Found!</b>

                                </div> */}
                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            checked={
                              listOfLedger.length > 0 &&
                              selectedStudents.length === listOfLedger.length
                            }
                            onChange={(e) => {
                              const pageChallanNos = listOfLedger
                                .map((item) => String(item.Challan_No || "").trim())
                                .filter(Boolean);

                              if (e.target.checked) {
                                // Keep existing cross-page selections and add current page challans.
                                setselectedStudents((prev) => {
                                  const merged = new Set([...(prev || []), ...pageChallanNos]);
                                  return Array.from(merged);
                                });
                              } else {
                                // Remove only current page challans; keep selections from other pages.
                                setselectedStudents((prev) =>
                                  (prev || []).filter((id) => !pageChallanNos.includes(id))
                                );
                              }
                            }}
                          />
                        </div>
                      </th>

                      <th>Challan No</th>
                      <th>Student ID</th>
                      <th>Reg No</th>
                      <th>Name</th>
                      <th>Father Name</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>Month</th>
                      <th>Due Date</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="13">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                </table>
                {totalRecords > 10 && (
                  <div className="pagination-wrap">
                    <div className="row align-items-center">
                      <div className="col-md-2 form_default">
                        <div className="d-flex align-items-center">
                          <label className="me-2" style={{ fontSize: "15px" }}>
                            Page Size
                          </label>
                          <div className="form-group">
                            <select
                              className="form-select"
                              style={{ width: "100px" }}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value));
                              }}
                            >
                              <option value="10" selected>
                                10
                              </option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <Pagination
                        pageNo={pageNo}
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container">
            <Form
              noValidate
              validated={validatedPrint}
              onSubmit={handlePrintVoucher}
            >
              <div className="card mt-2">
                <div className="card-body">
                  <div className="section-title title-sm title-left">
                    Print Vouchers for Selected Challans
                  </div>
                  <div className="row">
                    <div className="col-md-6"></div>
                  </div>
                  <div className="row">
                    <div className="col-md-3 text-end">
                      <button
                        type="button"
                        onClick={handleOpenPrintVouchers}
                        className="button button-primary w-100"
                      >
                        Print Vouchers
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>

          <div className="container">
            <div className="card mt-3">
              <div className="card-body">
                <div className="section-title title-sm title-left mb-2">
                  Bulk update challan remarks
                </div>
                <p className="text-muted small mb-3">
                  Set the same <strong>Remarks</strong> value on{" "}
                  <strong>tblChalanHead</strong> for challans you have ticked in the
                  list, or for every challan that matches your current search filters
                  (including other pages). Leave the text empty to clear remarks.
                </p>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    maxLength={4000}
                    value={bulkRemarksText}
                    onChange={(e) => setBulkRemarksText(e.target.value)}
                    placeholder="Text saved on each challan (max 4000 characters)"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="radio"
                    id="bulk-remarks-selected"
                    name="bulkRemarksScope"
                    label={`Selected challans only (${selectedStudents.length} selected)`}
                    checked={bulkRemarksScope === "selected"}
                    onChange={() => setBulkRemarksScope("selected")}
                  />
                  <Form.Check
                    type="radio"
                    id="bulk-remarks-filtered"
                    name="bulkRemarksScope"
                    label={`All challans matching current filters (${totalRecords} total, all pages)`}
                    checked={bulkRemarksScope === "filtered"}
                    onChange={() => setBulkRemarksScope("filtered")}
                  />
                </Form.Group>
                <button
                  type="button"
                  className="button button-primary"
                  disabled={bulkRemarksLoading}
                  onClick={handleBulkRemarksUpdate}
                >
                  {bulkRemarksLoading ? "Updating…" : "Update remarks"}
                </button>
              </div>
            </div>
          </div>

          {/* Convert to Installments Modal */}
          <Modal show={showInstallmentModal} onHide={() => !installmentSubmitting && setShowInstallmentModal(false)} backdrop="static">
            <Modal.Header closeButton={!installmentSubmitting}>
              <Modal.Title>Convert to Installments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="text-muted small mb-3">
                Convert challan <strong>{installmentChallanNo}</strong> into multiple sub-challans (max 4). The total amount will be divided equally. Select due dates for each installment.
              </p>
              <Form.Group className="mb-3">
                <Form.Label>Number of installments</Form.Label>
                <Form.Select value={installmentCount} onChange={handleInstallmentCountChange} disabled={installmentSubmitting}>
                  <option value={2}>2</option>
                  <option value={3}>3</option>
                  <option value={4}>4</option>
                </Form.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label>Due date for each installment</Form.Label>
                {installmentDueDates.map((dateVal, idx) => (
                  <div key={idx} className="mb-2">
                    <Form.Label className="small text-muted">Installment {idx + 1}</Form.Label>
                    <Form.Control
                      type="date"
                      value={dateVal || ""}
                      onChange={(e) => handleInstallmentDueDateChange(idx, e.target.value)}
                      disabled={installmentSubmitting}
                    />
                  </div>
                ))}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowInstallmentModal(false)} disabled={installmentSubmitting}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleConvertToInstallments} disabled={installmentSubmitting}>
                {installmentSubmitting ? "Converting…" : "Convert to Installments"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default PrintVouchers;
